/**
 * Terrain-based hero image pools — all verified colorful running photos from Unsplash.
 *
 * Selection is DETERMINISTIC: pickHero(race.id, terrain) uses race.id % pool.length
 * so the same race always shows the same photo (no flicker on re-render).
 */

// 5 trail running photos — forests, mountains, trails (all confirmed colorful)
const TRAIL_POOL = [
  'https://images.unsplash.com/photo-1588038265723-9bd2a2b03a82?w=1600&q=80&fit=crop', // 2 men running in forest
  'https://images.unsplash.com/photo-1623390003553-4fa3f9fceb89?w=1600&q=80&fit=crop', // man in red running through forest
  'https://images.unsplash.com/photo-1530143311094-34d807799e8f?w=1600&q=80&fit=crop', // man running on mountain
  'https://images.unsplash.com/photo-1504025468847-0e438279542c?w=1600&q=80&fit=crop', // runner on mountain edge (vivid)
  'https://images.unsplash.com/photo-1702449414685-1ed9316b7253?w=1600&q=80&fit=crop', // man running on wooded trail
];

// 5 road running photos — races, marathons, roads (all confirmed colorful)
const ROAD_POOL = [
  'https://images.unsplash.com/photo-1596460658047-1826d5921c56?w=1600&q=80&fit=crop', // group running on road
  'https://images.unsplash.com/photo-1598011872583-100f9b06de80?w=1600&q=80&fit=crop', // man running road daytime
  'https://images.unsplash.com/photo-1758586326115-d4e9052b8f06?w=1600&q=80&fit=crop', // three marathon runners
  'https://images.unsplash.com/photo-1769876579499-7479e1b4e415?w=1600&q=80&fit=crop', // athletes on paved road
  'https://images.unsplash.com/photo-1598014514548-27c9cd1c8466?w=1600&q=80&fit=crop', // man in orange shirt on road
];

const TRACK_POOL = [
  'https://images.unsplash.com/photo-1564349683136-77e08dba1ef7?w=1600&q=80&fit=crop',
];

const MIXED_POOL = [
  'https://images.unsplash.com/photo-1513593771513-7b58b6c4af38?w=1600&q=80&fit=crop',
];

const POOLS: Record<string, string[]> = {
  trail: TRAIL_POOL,
  road:  ROAD_POOL,
  track: TRACK_POOL,
  mixed: MIXED_POOL,
};

const DEFAULT_HERO = ROAD_POOL[0];

/**
 * Pick a hero image deterministically for a given race.
 * Same race ID + terrain always returns the same URL.
 */
export function pickHero(raceId: number, terrain?: string | null): string {
  const pool = terrain ? POOLS[terrain] : null;
  if (!pool) return DEFAULT_HERO;
  return pool[raceId % pool.length];
}
